import classnames from 'classnames';

import type { SearchedVehicle } from './types';
import VehicleIdentifier from './VehicleIdentifier';

import { ConnectivityState, Severity } from 'API';

import './styles/Vehicle.scss';

const Vehicle = ({ name, vin, licensePlate, connectivityStatus, severity }: SearchedVehicle) => (
    <div className='Vehicle'>
        <div
            data-testid='vehicle-status'
            className={classnames('Vehicle__severity', {
                'Vehicle__severity--fatal': severity === Severity.FATAL,
                'Vehicle__severity--error': severity === Severity.ERROR,
                'Vehicle__severity--warning': severity === Severity.WARNING,
                'Vehicle__severity--offline':
                    severity === Severity.UNKNOWN && connectivityStatus?.state !== ConnectivityState.ONLINE,
            })}
        />
        <VehicleIdentifier
            name={name}
            licensePlate={licensePlate}
            vin={vin}
            connectivityState={connectivityStatus?.state}
        />
    </div>
);

export default Vehicle;
